module.exports = "<div class=\"m-grid__item m-grid__item--fluid  m-grid m-grid--ver m-container m-container--responsive m-container--xxl m-page__container c-full_width\">\r\n\t<router-outlet></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /home/node/src/app/theme/pages/aside-left-display-disabled/aside-left-display-disabled.component.html
// module id = ../../../../../src/app/theme/pages/aside-left-display-disabled/aside-left-display-disabled.component.html
// module chunks = main